import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_PROMISE = loadStripe(
  import.meta.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);
